module.exports = __webpack_public_path__ + "img/other-services-banner.589200fa.jpg";